import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <>
      <ul className=" relative xxs:text-4xl xs:text-6xl rotate-6 text-blue-700 z-30 font-child font-extrabold">
        <li className="">
          <Link to="/" className=" cursor-pointer">
            <img
              src={require('../../assets/images/m1.png')}
              alt="home"
              className=" xxs:w-[200px] sm:w-[200px]   xxs:h-[80px] sm:h-[80px]"
            />
          </Link>
        </li>
        <li className=" ">
          <Link to="/story" className=" cursor-pointer">
            <img
              src={require('../../assets/images/m2.png')}
              alt="story"
              className=" xxs:w-[200px]  sm:w-[200px]  xxs:h-[80px] sm:h-[80px]"
            />
          </Link>
        </li>
        <li className=" ">
          <Link to="/join" className=" cursor-pointer">
            <img
              src={require('../../assets/images/m3.png')}
              alt="join"
              className=" xxs:w-[200px]  sm:w-[200px]  xxs:h-[80px] sm:h-[80px]"
            />
          </Link>
        </li>
        <li className=" ">
          <Link to="/mint" className=" cursor-pointer">
            <img
              src={require('../../assets/images/m4.png')}
              alt="mint"
              className=" xxs:w-[200px]  sm:w-[200px]  xxs:h-[80px] sm:h-[80px]"
            />
          </Link>
        </li>
      </ul>
    </>
  );
};

export default Navbar;
